export enum MathOperations {
  MULTIPLY = 'multiply',
  DIVIDE = 'divide',
  ADD = 'add',
  SUBTRACT = 'subtract',
}
